﻿window.cObjetModeReglementMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Mode de règlement"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau mode de règlement"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = objet.data.nom }
        else {
            txt = "Mode de règlement"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetLstDataModeReglementDispo = function () {
        return objet.bddRef.mGetArray("mode_reglement").filter(function (modeReg) {
            return (modeReg.abandon == "0" && modeReg.visible_interface == "1")
        })
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        if (typeof dataTemplate == "undefined") { $Icone = $("<i class='fas fa-piggy-bank'></i>"); }
        else {
            if (dataTemplate.id_mode_reglement == null) { $Icone = $("<i class='fas fa-xmark'></i>"); }//aucun reglement
            else {
                switch (parseInt(dataTemplate.id_mode_reglement)) {
                    case 0: $Icone = $("<i class='fas fa-xmark'></i>"); break; //aucun reglement
                    case 1: $Icone = $("<i class='fas fa-credit-card' style='position:relative'><i class='fas fa-calculator dx-theme-accent-as-text-color' style='position:absolute;bottom:0;right:0;font-size:60%;'></i></i>"); break; //cb
                    case 2: $Icone = $("<i class='fas fa-money-bill-transfer'></i>"); break; //virement
                    case 3: $Icone = $("<i class='fas fa-money-check'></i>"); break; //chèque
                    case 4: $Icone = $("<i class='fas fa-circle-dollar-to-slot'></i>"); break; //Espèce
                    case 9: $Icone = $("<i class='fas fa-money-bills'></i>"); break; //avoir client
                    case 10: $Icone = $("<i class='fas fa-gift'></i>"); break; //ticket cadeau
                    case 11: $Icone = $("<i class='fas fa-coins'></i>"); break; //ticket cadeau
                    case 12: $Icone = $("<i class='fas fa-hotel'></i>"); break; //centrale resa
                    case 13: $Icone = $("<i class='fas fa-credit-card' style='position:relative'><i class='fas fa-globe dx-theme-accent-as-text-color' style='position:absolute;bottom:0;right:0;font-size:60%;'></i></i>"); break; //cb internet
                    default: $Icone = $("<i class='fas fa-piggy-bank'></i>"); break; //autres modes
                }
            }
        }
        $Icone.attr("Mode de règlement")
        return $Icone
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

        $TableMenu = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($TableMenu)
        var $Td = $("<td style='width:1px;white-space:nowrap;'/>").appendTo($Tr)
        var dxBtNewModeReglement = $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-piggy-bank",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            txtTooltip: "Créer un nouveau mode de règlement",
            height: HeightEntete - 2,
            width: HeightEntete - 2,
            onClick: function (e) {
                var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    title: "Créer un nouveau mode de réglement",
                    showMaximize: false,
                    height: "auto",
                    width: 500,
                    hideOnOutsideClick:true,
                    contentTemplate: function (contentElement) {
                        $("<div/>").appendTo(contentElement).html("Vous souhaitez créer un nouveau mode de règlement ?<br/>Contactez le support " + parametre.nom + " en ouvrant un ticket ou en prenant un rendez-vous téléphonique.<br/><br/>La réglementation fiscale nous autorise à ajouter de nouveaux modes de règlement uniquement dans des cadres d’utilisation très précis. Toute modification non conforme peut entraîner des sanctions.<br/><br/>N’hésitez pas à nous contacter afin que nous puissions vous accompagner.")
                    }
                }).dxCtrlPopupBase("instance")
                pop.show()
                //Me.mShowPopupModeReglement(Me.objet.bddRef.getObjet("mode_reglement").mGetNewData());
            }
        }).dxCtrlButton("instance")
        $DivGrid = $("<div style='width:100%;height:calc(100% - " + $TableMenu.innerHeight() + "px);'/>").appendTo(contentElement)

        var optGrid = {
            bddCtrl: Me.objet.bddRef,
            getHeight: function () { return contentElement.innerHeight() - $TableMenu.innerHeight() },
            getMaxHeight: function () { return contentElement.innerHeight() - $TableMenu.innerHeight() },
            height: contentElement.innerHeight() - $TableMenu.innerHeight(),
            //dataSource: new DevExpress.data.DataSource({
            //    store: Me.objet.bddRef.mGetStore("mode_reglement"),
            //    filter: ["visible_interface", "=", "1"],
            //    reshapeOnPush: true
            //}),
            dataSource: new DevExpress.data.DataSource({
                store: new DevExpress.data.ArrayStore({
                    key: "id_mode_reglement",
                    data: Me.objet.bddRef.mGetStore("mode_reglement").array
                }),
                filter: ["visible_interface", "=", "1"],
                reshapeOnPush: true
            }),
            showColumnHeaders: false,
            width: "100%",
            noDataText: "Aucun mode de règlement",
            hoverStateEnabled: true,
            selection: { mode: "single" },
            onKeyDown: function (e) { if (e.event.keyCode == 13) e.handled = true; },
            columns: [{
                dataType: 'string', width: 60,
                cellTemplate: function (cellElement, cellInfo) {
                    cellElement.css("font-size", '150%')
                    //cellElement.css("padding-left", '5px')
                    //cellElement.css("padding-right", '5px')
                    var objApp = Me.objet.bddRef.getObjet(cellInfo.data)
                    objApp.mGetIcone().appendTo(cellElement);
                }
            }, {
                dataField: "nom", caption: "Nom mode de règlement", dataType: 'string',
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div/>").appendTo(cellElement).dxCtrlTextBox({
                        value: cellInfo.data.nom,
                        label: "Nom mode de règlement",
                        placeholder: "Nom ddu mode de règlement...",
                        labelMode: 'floating',
                        inputAttr: { autocomplete: 'test-autocomplete' },
                        onValueChanged: function (e) {
                            if (e.value == null || e.value.length == 0) {
                                window.setTimeout(function () { mNotify("Vous devez saisir un nom pour le mode de règlement", "warning", 6000) }, 0)
                                e.component.option("value", cellInfo.data.nom)
                            } else {
                                if (cellInfo.data.nom != e.value) {
                                    cellInfo.data.nom = e.value
                                    Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("nom")
                                }
                            }
                        }
                    })
                }
            }, {
                dataField: "is_internet", caption: "Internet", dataType: 'string',
                width: 170,
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div style='padding:5px;margin:25px;'/>").appendTo(cellElement).dxCtrlCheckBox({
                        //labelMode: 'floating',
                        //label: "Abandonné",
                        disabled: (cellInfo.data.id_mode_reglement == "1"),
                        value: (cellInfo.data.is_internet == "1"),
                        text: "Dispo. internet",
                        onValueChanged: function (e) {
                            cellInfo.data.is_internet = ((e.value) ? "1" : "0")
                            Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("is_internet")
                        }
                    }).dxCtrlCheckBox("instance")
                }
            }, {
                dataField: "abandon", caption: "Abandon", dataType: 'string',
                width: 170,
                cellTemplate: function (cellElement, cellInfo) {
                    $("<div style='padding:5px;margin:25px;'/>").appendTo(cellElement).dxCtrlCheckBox({
                        //labelMode: 'floating',
                        //label: "Abandonné",
                        value: (cellInfo.data.abandon == "1"),
                        text: "Abandonné",
                        onValueChanged: function (e) {
                            cellInfo.data.abandon = ((e.value) ? "1" : "0")
                            Me.objet.bddRef.getObjet(cellInfo.data).mSaveChamp("abandon")
                        }
                    }).dxCtrlCheckBox("instance")
                }
            }],
            iconeElement: "fas fa-piggy-bank"
        }

        var dxGrid = $("<div/>").appendTo($DivGrid).dxCtrlGridSimple(optGrid).dxCtrlGridSimple("instance");

        Me.objet.bddRef.mAddFunctionOnModifiedItemData("mode_reglement", dxGrid.element(), function (action, itemData, nomChamp) {
            dxGrid.refresh(false)
        })
    }

    this.mShowPopupModeReglement = function (dataModeReglement) {
        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupBase({
            title: ((dataModeReglement.id_mode_reglement == null) ? "Nouveau mode de règlement" : "Modifier mode de règlement"),
            showMaximize: false,
            height: 280,
            width: 360,
            contentTemplate: function (contentElement) {
                var dxNom = null
                var items = [{
                    dataField: "nom", name: "nom", label: { visible: false, text: "Nom", location: "left" },
                    template: function (itemData, itemElement) {
                        dxNom = $("<div class='dxctrlfocus'/>").appendTo(itemElement).dxCtrlTextBox({
                            value: dataModeReglement.nom,
                            label: "Nom",
                            placeholder: "Nom du mode de règlement...",
                            labelMode: 'floating',
                            inputAttr: { autocomplete: 'test-autocomplete' },
                            onValueChanged: function (e) {
                                dataModeReglement.nom = e.value;
                            }
                        }).dxCtrlTextBox("instance")
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                }]
                var form = $("<div style='padding-bottom:15px'/>").appendTo(contentElement).dxCtrlForm({
                    labelMode: 'floating',
                    showColonAfterLabel: true,
                    labelLocation: 'left',
                    formData: dataModeReglement,
                    items: items
                }).dxCtrlForm("instance");
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (dxNom.option("value") == null || dxNom.option("value").length == 0) {
                            mNotify("Vous devez saisir un nom pour le mode de règlement", "warning", 6000)
                            dxNom.focus()
                            return
                        }
                        Me.objet.bddRef.getObjet(dataModeReglement).mSave()
                        pop.hide()
                    },
                    function () { //annuler
                        pop.hide();
                    })
            }
        }).dxCtrlPopupBase("instance")
        pop.show();
    }

}